import React from 'react';
import './title.css'

const Title = (props) => {
    return ( <>
    <p className={props.t}>
        {props.title}
    </p>
    </> );
}
 
export default Title;